import {
    CreateButton,
    DataTable,
    DateField,
    EditButton,
    ExportButton,
    List,
    ReferenceField,
    TextField,
} from '@/components/admin';
import { Badge } from '@/components/ui/badge';
import { Card } from '@/components/ui/card';
import { Clock } from 'lucide-react';
import { StatusBadgeField } from '../documents/shared/StatusBadge';
import { TopToolbar } from '../layout/TopToolbar';

const DesignRequestListActions = () => (
    <TopToolbar>
        <CreateButton />
        <ExportButton />
    </TopToolbar>
);

export const DesignRequestList = () => {
    return (
        <List 
            actions={<DesignRequestListActions />}
            sort={{ field: 'requested_at', order: 'DESC' }}
            className="p-6"
        >
            <Card className="border-none shadow-sm overflow-hidden">
                <DataTable rowClick="show">
                    <DataTable.Col 
                        source="reference" 
                        label="Design Request No." 
                        className="font-mono font-bold text-blue-600"
                    />
                    <DataTable.Col 
                        source="title" 
                        label="Title" 
                        className="font-medium max-w-[200px] truncate"
                    />
                    <DataTable.Col label="Project">
                        <ReferenceField source="project_id" reference="projects" link={false}>
                            <span className="font-semibold text-foreground">
                                <TextField source="name" />
                            </span>
                        </ReferenceField>
                    </DataTable.Col>
                    <DataTable.Col 
                        label="Priority"
                        render={(record) => {
                            const colors = {
                                low: 'bg-muted text-foreground',
                                medium: 'bg-blue-100 text-blue-700',
                                high: 'bg-orange-100 text-orange-700',
                                urgent: 'bg-red-100 text-red-700',
                            };
                            return (
                                <Badge className={`${colors[record.priority as keyof typeof colors] || colors.medium} border-none`}>
                                    {String(record.priority).toUpperCase()}
                                </Badge>
                            );
                        }}
                    />
                    <DataTable.Col label="Status">
                        <StatusBadgeField source="status" />
                    </DataTable.Col>
                    <DataTable.Col label="Requested At">
                        <div className="flex items-center gap-2 text-muted-foreground">
                            <Clock className="w-3.5 h-3.5" />
                            <DateField source="requested_at" />
                        </div>
                    </DataTable.Col>
                    <DataTable.Col>
                        <EditButton />
                    </DataTable.Col>
                </DataTable>
            </Card>
        </List>
    );
};
